// hooks/useAssetList.js
import { useEffect, useState, useCallback } from "react";
import { useAxiosAuth } from "./useAxiosAuth";

export function useAssetList(assetType, courseId, lessonId) {
  const axios = useAxiosAuth();

  const [items, setItems] = useState([]);
  const [byRel, setByRel] = useState({});

  // --- fetch helper -------------------------------------------------
  const fetchAssets = useCallback(() => {
    if (!courseId) return Promise.resolve();

    const endpoint = `/assets/${assetType}`;
    return axios
      .get(endpoint, { params: { course_id: courseId, lesson_id: lessonId } })
      .then(({ data }) => {
        setItems(data);
        setByRel(
          Object.fromEntries(
            data.map((it) => [relativePath(it.gcs_link), it])
          )
        );
      })
      .catch(console.error);
  }, [axios, assetType, courseId, lessonId]);

  // run on mount / when deps change — but DON'T return the promise
  useEffect(() => {
    fetchAssets();
    // optional: add ignore flag or AbortController for cancellation
  }, [fetchAssets]);

  // optimistic local insert / update
  const upsert = useCallback((asset) => {
    const rel = relativePath(asset.gcs_link);
    setByRel((prev) => ({ ...prev, [rel]: asset }));
    setItems((prev) => {
      const i = prev.findIndex((x) => x.visual_id === asset.visual_id);
      if (i === -1) return [...prev, asset];
      const clone = [...prev];
      clone[i] = asset;
      return clone;
    });
  }, []);

  return { items, byRel, refresh: fetchAssets, upsert };
}

/**
 * ".../visuals/foo.html" → "visuals/foo.html"
 */
export function relativePath(url) {
  const parts = url.split("/");
  return parts.slice(-2).join("/");
}
